import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Verificar si fbq ya existe (evitar duplicados)
    if ((window as any).fbq) {
      return;
    }
    // Meta Pixel Code
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Esperar a que el script cargue
    setTimeout(() => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('init', '2369569976826317');
        (window as any).fbq('track', 'PageView');
      }
    }, 500);
  }, []);
  return <noscript data-id="element-122">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2369569976826317&ev=PageView&noscript=1" data-id="element-123" />
    </noscript>;
}